import React, { createContext, useContext } from 'react';

const HeaderActionsContext = createContext(null);

export const HeaderActionsProvider = ({ children, value }) => (
  <HeaderActionsContext.Provider value={value}>
    {children}
  </HeaderActionsContext.Provider>
);

export const useSetHeaderActions = () => {
  const setter = useContext(HeaderActionsContext);
  return setter;
};

export default HeaderActionsContext;
